/**
 * Read the calendar date from an API value without converting timezones.
 * "2026-10-31T00:00:00.000Z" always displays as 31-10-2026, including in Canada.
 */
export const getApiCalendarParts = (dateStr) => {
  if (!dateStr) return null;
  const match = String(dateStr).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) {
    return { year: match[1], month: match[2], day: match[3] };
  }
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return null;
  return {
    year: String(date.getUTCFullYear()),
    month: String(date.getUTCMonth() + 1).padStart(2, "0"),
    day: String(date.getUTCDate()).padStart(2, "0"),
  };
};

export const formatApiDate = (
  dateStr,
  { separator = "-", fallback = "N/A" } = {}
) => {
  const parts = getApiCalendarParts(dateStr);
  if (!parts) return fallback;
  return `${parts.day}${separator}${parts.month}${separator}${parts.year}`;
};
